// ─── Status labels ─────────────────────────────────────────────────────────

export const STATUS_LABELS = {
  1: {
    key: "in_work",
    label: "In Work",
    color: "bg-amber-100 text-amber-800 border-amber-200",
    dot: "bg-amber-500",
  },
  2: {
    key: "confirmed",
    label: "Confirmed",
    color: "bg-emerald-100 text-emerald-800 border-emerald-200",
    dot: "bg-emerald-500",
  },
  3: {
    key: "confirmed_print",
    label: "Confirmed Print",
    color: "bg-teal-100 text-teal-800 border-teal-200",
    dot: "bg-teal-500",
  },
  4: {
    key: "not_confirmed",
    label: "Not Confirmed",
    color: "bg-red-100 text-red-800 border-red-200",
    dot: "bg-red-500",
  },
  5: {
    key: "canceled",
    label: "Canceled",
    color: "bg-rose-100 text-rose-800 border-rose-200",
    dot: "bg-rose-400",
  },
  6: {
    key: "accepted_for_processing",
    label: "Accepted",
    color: "bg-slate-100 text-slate-700 border-slate-200",
    dot: "bg-slate-400",
  },
  7: {
    key: "not_confirmed_from_site",
    label: "From Site",
    color: "bg-orange-100 text-orange-800 border-orange-200",
    dot: "bg-orange-400",
  },
}
// ─── Table columns ──────────────────────────────────────────────────────────

export const ALL_COLUMNS = [
  { id: "num", label: "№", fixed: true },
  { id: "id", label: "ID / № запроса" },
  { id: "providers", label: "Поставщики / Код брони" },
  { id: "date_request", label: "Дата запроса" },
  { id: "client", label: "Клиент" },
  { id: "state", label: "Направление / Курорт" },
  { id: "hotel", label: "Отель / Тип номера" },
  { id: "checkin", label: "Заезд" },
  { id: "checkout", label: "Выезд" },
  { id: "departure", label: "Дата отъезда" },
  { id: "status", label: "Статус" },
]

// ─── Mock data ──────────────────────────────────────────────────────────────

export const MOCK_DATA = [
  {
    id: 56376,
    num: 1,
    status: "in_work",
    provider: "HotelStone",
    transport: "Tickets.ua",
    transfer: "Optima Travel Spain",
    insurance: "CTC-3482008",
    date: "11.05.2026 17:34",
    client: "MARTYSHOV VOLODYMYR\nNEZHURENKO IRYNA",
    state: "Испания\nМальграт де Мар",
    hotel: "Hotel Europa Splash & SPA\nHalf Board · standard\n2adl",
    checkin: "21.07.2026",
    checkout: "30.07.2026",
    departure: "Бухарест → Барселона",
  },
  {
    id: 56374,
    num: 2,
    status: "in_work",
    provider: "Gepard Travel Turkey",
    transport: "JETIT 214ZAF 14MAY",
    transfer: "Gepard Travel Turkey",
    insurance: "CTC-3482006",
    date: "11.05.2026 17:21",
    client: "VASYLIEVA IRYNA\nVASYLIEV MAKAR",
    state: "Турция\nБелек",
    hotel: "SHERWOOD DREAMS RESORT\nULTRA ALL INCLUSIVE · sea view\n1adl+1chd",
    checkin: "14.06.2026",
    checkout: "24.06.2026",
    departure: "Кишинёв → Анталия",
  },
  {
    id: 56360,
    num: 3,
    status: "new",
    provider: "JOYCE TRAVEL",
    insurance: "CTC-3481993",
    date: "11.05.2026 13:18",
    client: "TEST TEST\nTEST TEST",
    state: "Египет\nНабк Бей",
    hotel: "REHANA ROYAL BEACH RESORT\nPREMIUM UAI 24H · Deluxe\n2adl",
    checkin: "27.08.2026",
    checkout: "03.09.2026",
    departure: "",
  },
  {
    id: 56359,
    num: 4,
    status: "in_work",
    provider: "Summer Tour Turkey",
    transport: "JETIT 213YNM 14MAY",
    date: "11.05.2026 11:39",
    client: "KHOMENKO ANASTASIIA\nZINCHUK ALINA",
    state: "Турция\nАлания",
    hotel: "CLUB TURTAS\nALL INCLUSIVE · land view\n2adl+1chd",
    checkin: "20.06.2026",
    checkout: "25.06.2026",
    departure: "Кишинёв → Анталия",
  },
  {
    id: 56341,
    num: 5,
    status: "confirmed",
    provider: "HotelStone",
    transport: "Tickets.ua",
    date: "10.05.2026 09:12",
    client: "IVANOVA OLENA\nIVANOV PETRO",
    state: "Греция\nКрит",
    hotel: "Creta Palace\nAll Inclusive · Family Room\n2adl+2chd",
    checkin: "05.07.2026",
    checkout: "15.07.2026",
    departure: "Кишинёв → Ираклион",
  },
  {
    id: 56330,
    num: 6,
    status: "canceled",
    provider: "Coral Travel",
    date: "09.05.2026 14:55",
    client: "SHEVCHENKO DMYTRO",
    state: "ОАЭ\nДубай",
    hotel: "Atlantis The Palm\nBreakfast · Deluxe King\n1adl",
    checkin: "01.08.2026",
    checkout: "08.08.2026",
    departure: "Одесса → Дубай",
  },
]

// ─── Filter select options ──────────────────────────────────────────────────

// export const OPT = {
//   status: STATUS_LABELS.map((s) => ({ value: s.id, label: s.label })),
//   referer: [
//     { value: "r1", label: "Referrer A" },
//     { value: "r2", label: "Referrer B" },
//     { value: "r3", label: "Direct" },
//   ],
//   package: [
//     { value: "p1", label: "Standard" },
//     { value: "p2", label: "Premium" },
//     { value: "p3", label: "VIP" },
//   ],
//   sellers: [
//     { value: "s1", label: "Seller A" },
//     { value: "s2", label: "Seller B" },
//   ],
//   suppliers: [
//     { value: "sp1", label: "All suppliers" },
//     { value: "sp2", label: "HotelStone" },
//     { value: "sp3", label: "Gepard Travel" },
//   ],
//   users: [
//     { value: "u1", label: "Manager 1" },
//     { value: "u2", label: "Manager 2" },
//   ],
//   moderator: [
//     { value: "", label: "All" },
//     { value: "m2", label: "Moderator 1" },
//   ],
//   market: [
//     { value: "", label: "Market" },
//     { value: "mk2", label: "UA" },
//     { value: "mk3", label: "RO" },
//   ],
//   states: [
//     { value: "", label: "All countries" },
//     { value: "st2", label: "Украина" },
//     { value: "st3", label: "Молдова" },
//   ],
//   modules: [
//     { value: "", label: "Modules" },
//     { value: "mod2", label: "Hotels" },
//     { value: "mod3", label: "Tours" },
//   ],
//   services: [
//     { value: "sv1", label: "Hotel" },
//     { value: "sv2", label: "Transport" },
//     { value: "sv3", label: "Transfer" },
//     { value: "sv4", label: "Insurance" },
//   ],
//   paymentStatus: [
//     { value: "", label: "All" },
//     { value: "ps2", label: "Paid" },
//     { value: "ps3", label: "Unpaid" },
//   ],
//   displayResults: [
//     { value: "screen", label: "On screen" },
//     { value: "excel", label: "Excel" },
//   ],
//   roomStatus: [
//     { value: "", label: "Room Status" },
//     { value: "rs2", label: "Available" },
//     { value: "rs3", label: "Occupied" },
//   ],
//   searchBy: [
//     { value: "order", label: "Order ID" },
//     { value: "client", label: "Client" },
//     { value: "hotel", label: "Hotel" },
//   ],
// }

// ─── Empty filter state factory ─────────────────────────────────────────────

export const mkRange = () => ({ from: null, to: null })

export const makeEmptyFilters = () => ({
  status: [],
  sellers: [],
  suppliers: [],
  users: [],
  referer: [],
  package: [],
  services: [],
  moderator: "",
  market: "",
  states: "",
  modules: "",
  paymentStatus: "",
  displayResults: "screen",
  roomStatus: "",
  searchBy: "order",
  search: "",
  dateRequest: mkRange(),
  dateCheckin: mkRange(),
  dateCheckout: mkRange(),
  condition: {
    deleted: false,
    archive: false,
    ticketsIssued: false,
    ticketsNotIssued: false,
    competitorPrice: false,
  },
  direction: "any",
})

// ─── Calendar helpers ───────────────────────────────────────────────────────

export const MONTHS = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
]
export const WDAYS = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"]

export function fmtDate(d) {
  if (!d) return ""
  return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`
}
export function sameDay(a, b) {
  return (
    a &&
    b &&
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  )
}
export function isBetween(d, a, b) {
  return !!(a && b && d > a && d < b)
}
export function buildMonthDays(y, m) {
  const days = []
  let dow = new Date(y, m, 1).getDay()
  dow = dow === 0 ? 6 : dow - 1
  for (let i = 0; i < dow; i++) days.push(null)
  const total = new Date(y, m + 1, 0).getDate()
  for (let d = 1; d <= total; d++) days.push(new Date(y, m, d))
  return days
}

export const REQUESTS_ALL_COLUMNS = [
  { id: "id", label: "№ заявки", fixed: true, default: true },
  { id: "status", label: "Статус", fixed: false, default: true },
  { id: "created_at", label: "Дата создания", fixed: false, default: true },
  { id: "from_date", label: "Дата заезда", fixed: false, default: true },
  { id: "to_date", label: "Дата выезда", fixed: false, default: true },
  { id: "nights", label: "Ночей", fixed: false, default: true },
  { id: "client", label: "Клиент", fixed: false, default: true },
  { id: "company_name", label: "Компания", fixed: false, default: true },
  { id: "user_name", label: "Агент", fixed: false, default: true },
  { id: "moderator", label: "Модератор", fixed: false, default: false },
  { id: "company_sum", label: "Сумма", fixed: false, default: true },
  { id: "service_type", label: "Тип услуги", fixed: false, default: false },
  { id: "room_status", label: "Статус размещения", fixed: false, default: false },
  { id: "referer", label: "Источник", fixed: false, default: false },
  { id: "onrequest", label: "По запросу", fixed: false, default: false },
  { id: "check_mode", label: "Режим проверки", fixed: false, default: false },
  { id: "prebooking", label: "Предбронирование", fixed: false, default: false },
  { id: "comment", label: "Комментарий", fixed: false, default: false },
  { id: "comment_admin", label: "Комментарий адм.", fixed: false, default: false },
  { id: "flights", label: "Рейсы", fixed: false, default: false },
  { id: "reservation", label: "Резервация", fixed: false, default: false },
  { id: "is_archive", label: "Архив / удалён", fixed: false, default: false },
  { id: "depart_places", label: "Места", fixed: false, default: false },
  { id: "competitor_price_request", label: "Запрос цены", fixed: false, default: false },
  { id: "not_show_price", label: "Скрыть цену", fixed: false, default: false },
]

export const OPT = {
  searchBy: [
    { value: "order", label: "№ заявки" },
    { value: "order_id", label: "ID" },
    { value: "tourist_name", label: "Турист" },
    { value: "tourist_phone", label: "Телефон" },
    { value: "hotel_name", label: "Отель" },
    { value: "state", label: "Страна" },
    { value: "city", label: "Город" },
    { value: "company_name", label: "Компания" },
    { value: "agent_name", label: "Агент" },
    { value: "module_order", label: "№ модуля" },
  ],

  status: [], // загружается с сервера

  sellers: [], // загружается с сервера
  suppliers: [], // загружается с сервера
  users: [], // загружается с сервера
  moderator: [], // загружается с сервера
  market: [], // загружается с сервера
  states: [], // загружается с сервера

  modules: [
    { value: "", label: "Все модули" },
    { value: "1", label: "Отель" },
    { value: "2", label: "Транспорт" },
    { value: "3", label: "Страховка" },
    { value: "4", label: "Трансфер" },
  ],

  services: [], // загружается с сервера
  package: [], // загружается с сервера
  referer: [], // загружается с сервера

  paymentStatus: [
    { value: "", label: "Все" },
    { value: "overpaid", label: "Переплата (>100%)" },
    { value: "paid", label: "Оплачено (99-101%)" },
    { value: "prepaid", label: "Предоплата (21-98%)" },
    { value: "low_payment", label: "Мало оплачено (1-20%)" },
    { value: "no_payment", label: "Не оплачено (0%)" },
  ],

  roomStatus: [
    { value: "", label: "Все статусы" },
    { value: "is_new", label: "Новый" },
    { value: "is_changed", label: "Изменён" },
    { value: "confirmed", label: "Подтверждён" },
    { value: "canceled", label: "Отменён" },
  ],

  displayResults: [
    { value: "display", label: "На экране" },
    { value: "xls", label: "Excel" },
    { value: "pdf", label: "PDF" },
  ],
}

export const buildOPT = (t) => ({
  searchBy: [
    { value: "order", label: t("requests.search_object.order", "№ заявки") },
    { value: "order_id", label: t("requests.search_object.order_id", "ID") },
    { value: "tourist_name", label: t("requests.search_object.tourist_name", "Турист") },
    { value: "tourist_phone", label: t("requests.search_object.tourist_phone", "Телефон") },
    { value: "hotel_name", label: t("requests.search_object.hotel_name", "Отель") },
    { value: "state", label: t("requests.search_object.state", "Страна") },
    { value: "city", label: t("requests.search_object.city", "Город") },
    { value: "company_name", label: t("requests.search_object.company_name", "Компания") },
    { value: "agent_name", label: t("requests.search_object.agent_name", "Агент") },
    { value: "module_order", label: t("requests.search_object.module_order", "№ модуля") },
  ],

  status: [],

  sellers: [], // загружается с сервера
  suppliers: [], // загружается с сервера
  users: [], // загружается с сервера
  moderator: [], // загружается с сервера
  market: [], // загружается с сервера
  states: [], // загружается с сервера

  modules: [
    { value: "", label: t("admin.all_modules", "Все модули") },
    { value: "1", label: t("admin.hotel", "Отель") },
    { value: "2", label: t("admin.transport", "Транспорт") },
    { value: "3", label: t("admin.insurance", "Страховка") },
    { value: "4", label: t("admin.transfer", "Трансфер") },
  ],

  services: [], // загружается с сервера
  package: [], // загружается с сервера
  referer: [], // загружается с сервера

  paymentStatus: [
    { value: "", label: t("admin.all", "Все") },
    { value: "overpaid", label: `${t("admin.payment_status_overpaid", "Переплата")} (>100%)` },
    { value: "paid", label: `${t("admin.payment_status_paid", "Оплачено")} (99-101%)` },
    { value: "prepaid", label: `${t("admin.payment_status_prepaid", "Предоплата")} (21-98%)` },
    { value: "low_payment", label: `${t("admin.partially_paid", "Мало оплачено")} (1-20%)` },
    { value: "no_payment", label: `${t("admin.payment_status_no_payment", "Не оплачено")} (0%)` },
  ],

  roomStatus: [
    { value: "", label: t("room_status.all") },
    { value: "is_new", label: t("room_status.new") },
    { value: "is_changed", label: t("room_status.changed") },
    { value: "confirmed", label: t("room_status.confirmed") },
    { value: "canceled", label: t("room_status.canceled") },
  ],

  displayResults: [
    { value: "display", label: t("trainees.on_screen", "На экране") },
    { value: "xls", label: "Excel" },
    { value: "pdf", label: "PDF" },
  ],
})
